import { render, staticRenderFns } from "./ListagemStatus.vue?vue&type=template&id=0aaa5a06"
import script from "./ListagemStatus.vue?vue&type=script&lang=js"
export * from "./ListagemStatus.vue?vue&type=script&lang=js"
import style0 from "./ListagemStatus.vue?vue&type=style&index=0&id=0aaa5a06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports